<template>
  <v-container fluid>
    <div class="modal-padding">
      <v-row v-if="this.omrDetails">
        <v-col cols="8" sm="8">
          Test ID : <span class="text-bold">{{ this.data && this.data.test_id || '-' }}</span>
        </v-col>
        <v-col cols="4" sm="4" class="text-bold pl-42">
          {{ this.data.test_name }}
        </v-col>

        <v-col cols="4" sm="4" class="zero-top">
          <div>Total Students: {{ this.omrDetails.total_student }}</div>
          <div>
            Response Details:
            <br>
            <span class="green-text">
              {{ this.items.length }} Evaluated
            </span>
            <span class="red-text">
              {{ this.omrDetails.failed_count || 0 }} Rejected 
            </span>
            <span class="">
              of {{ this.omrDetails.evaluated_count || 0 }} Students
            </span>
          </div>
        </v-col>
        <v-col cols="4" sm="4" class="zero-top">
        </v-col>
        <v-col cols="4" sm="4" class="zero-top">
          <div class="show-drop-down">
            <div class="field-data">
              <v-text-field hide-details="auto" v-model="search_query" label="Name/Student ID/Roll No." dense outlined
                append-icon="search">
              </v-text-field>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="zero-top">
          <div class="list-scroll-trip">
            <v-data-table :headers="headers" :items="items" hide-default-header hide-default-footer
              id="virtual-scroll-table" disable-pagination fixed-header height="400px" class="batch-elevation"
              ref="scrollContainer">
              <template v-slot:header="{ props: { headers } }" v-slot:top>
                <TableHeader :headers="headers" :orderBy="orderBy" :onSortChange="onSortChange" />
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.omr_file_id">
                    <td class="text-center">
                      <span v-if="getProcessedRollNo(item) !== item.student_id" class="blue-text">
                        {{ getProcessedRollNo(item) }}
                      </span>
                      <span v-else>
                        {{ item.student_id }}
                      </span>
                    </td>
                    <td class="text-center">{{ item.student_name }}</td>
                    <td class="text-center">{{ item.batch }}</td>
                    <td class="text-center">
                      {{ getFormatedDate(item.created_at) }}
                    </td>
                    <td class="text-center cursor-pointer">
                      <!-- <div :class="{
                        'green-text': item.job_status === 'C',
                        'red-text': item.job_status === 'F',
                        'blue-text': item.job_status === 'R' || item.job_status === 'M',
                      }" v-if="item.job_status !== 'M'">
                        {{ item.message }}
                      </div> -->
                      <div v-if="item.job_status === 'M'">
                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="cursor-pointer blue-text">{{ item.message }}</div>
                          </template>
                          <span>{{ 'Updated by ' + item.updated_by_name + ' at ' +
                            getFormatedDate(item.updated_at) + ' ' +
                            getFormatedTime(item.updated_at) }}</span>
                        </v-tooltip>
                      </div>
                      <div v-else>
                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="cursor-pointer">
                              <span v-if="item.job_status === 'N'">Image uploaded. Processing starts in {{
                                getProcessingTime(item.updated_at) }} minutes</span>
                              <span v-else-if="item.job_status === 'I'">Processing Image...</span>
                              <span v-else :class="{
                                'green-text': item.job_status === 'C',
                                'red-text': item.job_status === 'F' || item.job_status === 'R',
                                'blue-text': item.job_status === 'M',
                              }">{{ item.message }}</span>
                            </div>
                          </template>
                          <span>
                            {{ item.updated_by_name ? `Updated by ${item.updated_by_name} at
                            ${getFormatedDate(item.updated_at)}
                            ${getFormatedTime(item.updated_at)}` : `Updated at ${getFormatedDate(item.updated_at)}
                            ${getFormatedTime(item.updated_at)}` }}
                          </span>
                        </v-tooltip>
                      </div>
                    </td>
                    <td class="text-center">

                      <div v-if="item.source.toLowerCase() === 'omr'">

                        <v-tooltip left content-class="cust-new-tooltip-bottom">
                          <template v-slot:activator="{ on }">
                            <v-icon @click="previewOmr(item)" v-on="on">
                              mdi-file-image
                            </v-icon>
                          </template>
                          <span>Click here to download OMR image.</span>
                        </v-tooltip>
                      </div>

                    </td>
                      <td class="text-center" v-if="getButtonVisibility()">
                      <v-tooltip left content-class="cust-new-tooltip-bottom" v-if="item.job_status !== 'R'">
                        <template v-slot:activator="{ on }">
                          <v-icon @click="editOmr(item)" v-on="on">
                            mdi-pencil
                          </v-icon>
                        </template>
                        <span>Click here to view and update OMR responses. Updating is only possible after processing is
                          complete.</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
          <!-- <div v-else class="text-center">No records found</div> -->
        </v-col>
      </v-row>
    </div>

    <!-- OMR Edit Dialog -->
    <OmrEditPopup v-model="showOmrEditDialog" :omrId="selectedOmrId" @close="handleOmrEditClose" />
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import OmrEditPopup from './OmrEditPopup.vue';

export default {
  name: "LiveTracking",
  props: ["onClose", "status", "data"],
  components: {
    OmrEditPopup,
  },
  data() {
    return {
      loading: false,
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      centers: [],
      batches: [],
      items: [],
      search_query: "",
      omrDetails: null,
      headers: [
        {
          text: "Student ID / \n<span style='color: blue!important;'>Roll No.</span>",
          align: "center",
          class: "text-center header-fixed",
          hideSort: true,
          value: "roll_number",
        },
        {
          text: "Student Name",
          align: "center",
          class: "text-center header-fixed",
          value: "student_name",
        },
        {
          text: "Batch",
          align: "center",
          class: "text-center header-fixed",
          hideSort: true,
          value: "batch",
        },
        {
          text: "Upload Date",
          align: "center",
          class: "text-center header-fixed",
          value: "created_at",
        },
        {
          text: "Remarks",
          align: "center",
          class: "text-center header-fixed",
          hideSort: true,
          value: "message",
        },
        {
          text: "OMR",
          align: "center",
          class: "text-center header-fixed",
          hideSort: true,
          value: "omr_link",
        },
      ],
      allowScroll: false,
      rowCount: 0,
      typetimeout: 0,

      // OMR Edit Dialog
      showOmrEditDialog: false,
      selectedOmrId: null,

    };
  },

  computed: {
  },

  mounted() {
    this.resetPage();
    console.log('mounted');
    this.getOmrDetails();
  },
  beforeDestroy() {
    if (this.$refs && this.$refs.scrollContainer && this.$refs.scrollContainer.$el) {
      const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleScroll.bind(this));
      }
    }
  },
  methods: {
    ...mapActions({
      getOmrDetailsTestWise: "testStore/getOmrDetailsTestWise",
      getOmrResponseData: "testStore/getOmrResponseData",
    }),
    onSortChange() {
      console.log('onSortChange');
      this.items = [];
      this.currentPage = 1;
      this.getOmrDetails();
    },

    getButtonVisibility() {
      if (this.data.results_published_at) return false;

      const modules = JSON.parse(localStorage.getItem("modules")) || [];
      const currentDate = new Date();
      const qpdModule = modules.find(m => m.module_id === 14);
      this.hasQPDAccess = qpdModule && new Date(qpdModule.expiry_date) > currentDate;
      const stModule = modules.find(m => m.module_id === 15 );
      this.hasSTAccess = stModule && new Date(stModule.expiry_date) > currentDate;
      const AITsmodule = modules.find(m => m.module_id === 16 );
      this.hasAITAccess = AITsmodule ;

      if (this.hasQPDAccess && this.data.is_shared_test) {
        return true; 
      } else if(this.hasQPDAccess &&  this.hasSTAccess){
        return true; 
      } else if(this.hasQPDAccess && this.AITsmodule){
        return true; 
      }else if(this.hasQPDAccess && this.hasSTAccess && this.AITsmodule){
        return true; 
      }else{
        return false; 
      }
    },
    getOmrDetails() {
      this.$root.showLoader = true;
      let reqData = {
        test_schedule_id: this.data.schedule_id,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
        orderBy: {
          field: this.orderBy.field || 'student_id',
          order: this.orderBy.order || 'asc',
        },
        searchQuery: this.search_query || null,
      };
      this.getOmrDetailsTestWise(reqData)
        .then(res => {
          this.allowScroll = res.pagination.pageCount > this.currentPage;
          this.items = [...this.items, ...res.list];
          console.log('this.items', this.items);
          this.items = this.items.filter((a, i, arr) => arr.findIndex(b => b.omr_file_id === a.omr_file_id) === i);
           const modules = JSON.parse(localStorage.getItem("modules")) || [];
      const currentDate = new Date();
      const qpdModule = modules.find(m => m.module_id === 14);
      this.hasQPDAccess = qpdModule && new Date(qpdModule.expiry_date) > currentDate;
      const stModule = modules.find(m => m.module_id === 15 );
      this.hasSTAccess = stModule && new Date(stModule.expiry_date) > currentDate;
      const AITsmodule = modules.find(m => m.module_id === 16 );
      this.hasAITAccess = AITsmodule ;
      if(this.hasQPDAccess &&  this.hasSTAccess){
 this.items =  this.items.filter(item => ( item.source === 'excel' ||item.source === 'omr') );
 
      }
      if(this.hasQPDAccess &&  this.hasSTAccess && this.hasAITAccess){
 this.items =  this.items.filter(item =>  (item.source === 'excel'||item.source === 'omr')  );
      }


          this.omrDetails = res;
          this.rowCount = res.pagination.rowCount;
          this.totalPages = res.pagination.pageCount;
          this.$root.showLoader = false;
          this.currentPage = res.pagination.page;
          console.log(this.items, 'items after filter');
          setTimeout(() => {
            const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
            scrollContainer.addEventListener('scroll', this.handleScroll.bind(this));
          }, 2000);
        })
        .catch(err => {
          this.$root.showLoader = false;
        });
    },
    previewOmr(item) {
      console.log("item", item);

      window.open(item.omr_link, "_blank");
    },
    resetPage() {
      this.selectedCenter = [];
      this.selectedBatches = [];
      this.batches = [];
      this.items = [];
      this.currentPage = 1;
      this.search_query = "";
    },
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer.$el.querySelector('.v-data-table__wrapper');
      const scrollOffset = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight;
      if (scrollOffset <= 0) {
        if (this.rowCount > this.currentPage * this.pageSize) {
          this.currentPage++;
          this.getOmrDetails();
        }
      }
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
    },
    editOmr(item) {
      this.showOmrEditDialog = true;
      this.selectedOmrId = item.omr_file_id || null;
    },
    handleOmrEditClose() {
      this.showOmrEditDialog = false;
      this.selectedOmrId = null;

      // Refresh the data
      this.items = [];
      this.currentPage = 1;
      this.getOmrDetails();
    },
    getProcessingTime(updatedAt) {
      if (!updatedAt) return 'few';
      // Add 7 minutes to the updated_at time
      const processingStartTime = moment(updatedAt).add(3, 'minutes');
      const currentTime = moment();
      // Calculate the difference in minutes
      const diffInMinutes = processingStartTime.diff(currentTime, 'minutes');
      // If the difference is 0 or negative, return 'few'
      if (diffInMinutes <= 0) return 'few';
      return diffInMinutes;
    },
    getProcessedRollNo(item) {
      try {
        if(item.roll_number) return item.roll_number;
        if (!item.omr_processed_json) return item.student_id;
        
        const processedJson = typeof item.omr_processed_json === 'string' 
          ? JSON.parse(item.omr_processed_json)
          : item.omr_processed_json;

        const rollNo = processedJson['RollOG'] || processedJson['Roll'];
        return rollNo ? parseInt(rollNo) : item.student_id;
      } catch (error) {
        console.error('Error parsing omr_processed_json:', error);
        return item.student_id;
      }
    },
  },
  watch: {
    search_query() {
      if (this.typetimeout) {
        clearTimeout(this.typetimeout);
      }
      this.typetimeout = setTimeout(() => {
        this.items = [];
        this.allowScroll = false;
        this.currentPage = 1;
        this.getOmrDetails();
      }, 1500);
    },
    status(val) {
      this.resetPage();
      this.items = [];
      if (this.status) {
        this.allowScroll = false;
        this.getOmrDetails();
      }
      if (val) {
        clearInterval(this.timerID);
      }
    },
    data() {
      if (this.getButtonVisibility()) {
        const actCol = this.headers.find(hdr => hdr.text == "Actions");

        if (actCol) return;

        this.headers.push({
          text: "Actions",
          align: "center",
          class: "text-center header-fixed",
          hideSort: true,
        });
      } else {
        this.headers = this.headers.filter(hdr => hdr.text !== "Actions");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-elevation {
  overflow-y: auto;
}
</style>
